import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class FinalPitchDrive23 extends Widget {
	componentWillMount() {
		const dismissed = getCookie("tpm_dismiss_final_pitch") !== null;
		this.state.dismissed = dismissed;

		let views = getCookie("tpm_article_views");
		if (views === null) views = 0;
		else views = parseInt(views);

		//we DO want to count the first and current article view, but the pvt might not have got to it yet
		//(race condition). If didtrack is falsy, lets increment the views to account for that
		if (!window.tpm_pvt || !window.tpm_pvt.didtrack) {
			views = views + 1;
		}

		this.state.views = views;

		this.setCookie = this.setCookie.bind(this);
		this.dismiss = this.dismiss.bind(this);

		if (!this.state.dismissed) {
			const fullText = document.querySelector(".js_content-inner-full");
			const shortText = document.querySelector(".js_content-inner-short");
			if (fullText) fullText.classList.add("hidden");
			if (shortText) shortText.classList.remove("hidden");
			// shortText.classList.add('behind-pitch')
		}
	}

	setCookie() {
		setCookie("tpm_dismiss_final_pitch", 1, 100);
	}

	handleLinkClick(e) {
		e.preventDefault();
		this.setCookie();
		window.location = e.target.href;
	}

	dismiss() {
		this.setState({ dismissed: true }, () => {
			this.setCookie();

			const fullText = document.querySelector(".js_content-inner-full");
			const shortText = document.querySelector(".js_content-inner-short");

			// shortText.classList.remove('behind-pitch')
			if (fullText) fullText.classList.remove("hidden");
			if (shortText) shortText.classList.add("hidden");

			document.querySelector(".Article__Content ").scrollIntoView({
				behavior: "smooth",
			});
		});
	}

	handleThinkingClick() {
		this.dismiss();
	}

	handleNeverClick() {
		this.dismiss();
	}

	renderContent() {
		if (!!this.state.dismissed) return;
		return (
			<section
				id="content-pitch"
				class="MPDrive23 content-pitch js_content-pitch"
			>
				<div className="MPDrive23__Divider">
					<span>
						Scroll and respond to
						<br class="mobile-only" />
						&nbsp;read this article
					</span>
				</div>
				<div class="MPDrive23__PreHead">
					<img
						class="MPDrive23__Image --opacity-0"
						src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/tpm-membership-drive-badge-250.png`}
						alt="TPM's Annual Membership Drive"
						aria-hidden="true"
					/>
					<div class="MPDrive23__PreHeading">
						You've read {this.state.views} articles this month
						<br />
						but...
						<br />
						<b>THIS IS NOT A PAYWALL</b>
					</div>
					<img
						class="MPDrive23__Image"
						src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/tpm-membership-drive-badge-250.png`}
						alt="TPM's Annual Membership Drive"
						aria-hidden="true"
					/>
				</div>
				<div class="MPDrive23__Head">Give us just a minute of your time</div>
				<p>
					During our annual membership drive, we’ve lifted all paywalls. We wish
					we could do this all the time: We want as many people as possible to
					have access to our journalism. But our membership business model is
					what keeps TPM thriving, viable and independent.
				</p>

				<p>
					However, for this month only we’re giving everyone access. All we ask
					in return is that you read one final pitch. If you decide a TPM
					membership still isn’t for you, or you aren’t ready to join just yet,
					let us know at the bottom of this message, and then you can read the
					article and we won’t show this to you again on this device. Better
					yet, if you decide you do want to become a member, we’re offering 50%
					off any TPM membership, and you won’t see a pitch like this again on
					any device! So here it goes...
				</p>

				<p>
					As someone who’s read 10 articles this month, it’s likely that you are
					a regular TPM reader. You’ve probably seen many of our pitches and for
					whatever reason have decided not to pull the trigger. Or perhaps you
					have previously been a member and let that membership lapse. We get
					it. It seems like every publication is hounding its readers to join
					and there are only so many subscriptions a person can have and only so
					much money to go around. So why join TPM? What’s different about us?
				</p>

				<p>
					First, we don’t ever want money to be an obstacle to information. We
					offer completely free memberships. If the cost of a membership is a
					burden for any reason, just submit a request{" "}
					<a
						href="https://talkingpointsmemo.com/memberships/community?utm_source=on+site&utm_medium=final+pitch&utm_campaign=2023+membership+drive&utm_content=community"
						onClick={this.handleLinkClick}
					>
						here
					</a>
					. And if you’re a student, you can apply for a free membership{" "}
					<a
						href="https://talkingpointsmemo.com/memberships/create-student-account?utm_source=on+site&utm_medium=final+pitch&utm_campaign=2023+membership+drive&utm_content=student"
						onClick={this.handleLinkClick}
					>
						here
					</a>
					.
				</p>

				<p>
					Second, membership numbers aren’t meant to be a data point that we can
					bring to our investors or corporate backers as proof of growth. We
					don’t have any overlords. There are just the 15 of us on staff who
					work hard to put out the news each day. Membership fees pay our
					salaries and fund our operations, but the members themselves provide
					infinitely more. Members send us tips, write us emails with key
					insights, and alert us to important events or developments in their
					home state or in their fields of expertise. And for our part we try
					our best to heed the tips, respond to the emails, and learn from those
					who know more about a subject than we do. In this way our members
					become part of the way we make and present the news. TPM couldn’t
					exist without them.
				</p>

				<p>
					Lastly, there really is no other publication like TPM. Sure, lots of
					places cover politics — and a number of those can fairly claim to be
					independent. But none are as explicitly designed for this political
					moment as TPM, and few have the experience, expertise, and high level
					of journalistic standards that we do. For us, independence is a
					necessity, not a marketing ploy. Our total focus is poring over the
					entrails of the political moment, figuring out which stories matter
					and doing all we can to try to drive them forward. We genuinely don’t
					care if some politician or oligarch lands a virtual sucker punch on
					one of our reporters. We don’t care what anyone says about us. We have
					one rule that governs our work and after that all we care about is
					delivering for our readers.
				</p>
				<p>
					We’ve been doing this for over 20 years and we’re only getting better.
					We have big plans for the months and years ahead, but to sustain and
					expand our reporting powers, we need our regular readers to become
					members. We’d really love for you to join us!
				</p>

				<div class="MPDrive23__Footer">
					<a
						href="https://talkingpointsmemo.com/memberships?utm_source=on+site&utm_medium=final+pitch&utm_campaign=2023+membership+drive&utm_content=join"
						class="MPDrive23__Button Button --red"
						onClick={this.handleLinkClick}
					>
						Get 50% off any TPM membership
					</a>
					<div class="MPDrive23__Dismiss" onClick={this.dismiss}>
						I’m still thinking about it
					</div>
					<div class="MPDrive23__Dismiss" onClick={this.dismiss}>
						I'll never join
					</div>
				</div>
			</section>
		);
	}
}
